// 该文件集中处理所有的api地址
const qqHost = 'https://c.y.qq.com'

// 热门搜索关键字
export const hotSearchKeysmod = `${qqHost}/splcloud/fcgi-bin/gethotkey.fcg`

// 排行榜数据
export const recomList = `${qqHost}/v8/fcg-bin/fcg_first_yqq.fcg`

// 新歌速递
export const albumList = `${qqHost}/v8/fcg-bin/album_library`



// WEBPACK FOOTER //
// ./src/utils/API.js